<template>
  <el-container class="order-page">
    <el-aside width="200px" class="order-page-aside">
      <el-form class="query-form" label-position="top">
        <el-form-item label="订单号">
          <el-input v-model="queryForm.wholesaleOrderNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="集合单号">
          <el-input v-model.trim="queryForm.wholesaleMergeNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="买手店名称">
          <el-select v-model="queryForm.vendorId" filterable clearable>
            <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="买手店别名">
          <el-select v-model="queryForm.vendorAliasId" filterable clearable>
            <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.vendorId" :key="item.vendorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            style="width: 100%"
            v-model="daterange"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="~"
            start-placeholder="开始"
            end-placeholder="结束"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否集单">
          <el-select v-model="queryForm.isMerge" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货单ID">
          <el-input v-model="queryForm.goodsGroupNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="货单类型">
          <el-select v-model="queryForm.groupType" clearable>
            <el-option v-for="item in wholesaleOrderList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button @click="search" type="primary">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </el-aside>
    <el-container>
      <el-container>
        <el-header class="order-page-toolbar">
          <el-button type="primary" @click="batchMerge" :disabled="selection.length === 0">集合订单</el-button>
          <el-button type="primary" @click="batchRemove" :disabled="selection.length === 0">移除</el-button>
        </el-header>
        <el-main class="order-page-main">
          <el-table ref="table" :data="tableData" @selection-change="handleSelectionChange" @expand-change="expandChange" v-loading="loading" height="100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="expand" width="50">
              <template slot-scope="props">
                <div class="ml50">
                  <el-table :data="props.row.subList">
                    <el-table-column label="" width="80" class-name="nopadding">
                      <template slot-scope="scope">
                        <list-img :img="scope.row.coverImg" :width="30"></list-img>
                      </template>
                    </el-table-column>
                    <el-table-column prop="designerId" label="货号"></el-table-column>
                    <el-table-column prop="colorCode" label="颜色"></el-table-column>
                    <el-table-column prop="brandName" label="品牌"></el-table-column>
                    <el-table-column prop="categoryNamePath" label="品类"></el-table-column>
                    <el-table-column prop="seasonCode" label="季节"></el-table-column>
                    <el-table-column prop="productName" label="商品名称"></el-table-column>
                    <el-table-column prop="size" label="尺码"></el-table-column>
                    <el-table-column prop="productType" label="销售分类"></el-table-column>
                    <el-table-column prop="retailPrice" label="吊牌价€"></el-table-column>
                    <el-table-column prop="supplyPrice" label="供货价€"></el-table-column>
                    <el-table-column prop="salePrice" label="销售价€"></el-table-column>
                    <el-table-column prop="purchaserOrderNo" label="采购单号"></el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="wholesaleOrderNo" label="订单号"></el-table-column>
            <el-table-column prop="wholesaleOrderMergeNo" label="集合单号"></el-table-column>
            <el-table-column prop="totalAmount" label="集合订单金额"></el-table-column>
            <el-table-column prop="totalQuantity" label="集合订单数量"></el-table-column>
            <el-table-column prop="accountName" label="买手店">
              <template slot-scope="scope">
                <p>{{ scope.row.vendorName }}</p>
                <p>{{ scope.row.vendorNameAlias }}(别)</p>
              </template>
            </el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
            <el-table-column prop="createAt" label="生成时间">
              <template slot-scope="scope">
                {{ dateFormat(scope.row.createAt) }}
              </template>
            </el-table-column>
            <el-table-column prop="quantity" label="数量"></el-table-column>
            <el-table-column prop="amount" label="金额€"></el-table-column>
            <el-table-column prop="groupType" label="货单类型"></el-table-column>
            <el-table-column prop="goodsGroupNo" label="货单ID/活动ID"></el-table-column>
            <el-table-column prop="mergeAt" label="集合时间">
              <template slot-scope="scope">
                {{ dateFormat(scope.row.mergeAt) }}
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
      <el-footer height="40px">
        <el-pagination class="tr mt10"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.pageNo"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import {
  getComboVendorList,
} from '../crm/api';
import {
  getWholesaleOrderList,
  getWholesaleOrderDetail,
  mergeWholesaleOrder,
  removeWholesaleOrder,
  getWholesaleOrderType,
} from "./api";
import utils from '@/utils/util';
import ListImg from '../shared/ListImg.vue';

export default {
  components: {
    ListImg,
  },
  data() {
    return {
      loading: false,
      vendorList: [],
      wholesaleOrderList: [],
      wholesaleOrderMap: {},
      daterange: [],
      queryForm: {
        vendorId: null,
        vendorAliasId: null,
        wholesaleOrderNo: null,
        wholesaleMergeNo: null,
        isMerge: null,
        goodsGroupNo: null,
        groupType: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      selection: [],
    };
  },
  mounted() {
    getComboVendorList(true).then(res => {
      if (res.data) {
        this.vendorList = res.data.data || [];
      }
    })
    getWholesaleOrderType().then(res => {
      if (res.data) {
        const map = {};
        this.wholesaleOrderList = (res.data.data || []).map(item => {
          map[item.id] = item.desc;
          return {
            value: item.id,
            label: item.desc,
          };
        });
        this.wholesaleOrderMap = map;
      }
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.vendorAliasId = null;
      this.queryForm.wholesaleOrderNo = null;
      this.queryForm.wholesaleMergeNo = null;
      this.queryForm.isMerge = null;
      this.queryForm.goodsGroupNo = null;
      this.queryForm.groupType = null;
      this.queryForm.pageNo = 1;
      this.daterange = [];
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      let wholesaleOrderNos = [];
      if (this.queryForm.wholesaleOrderNo && this.queryForm.wholesaleOrderNo.includes(' ')) {
        wholesaleOrderNos = this.queryForm.wholesaleOrderNo.split(' ').filter(item => item);
      } else if (this.queryForm.wholesaleOrderNo && this.queryForm.wholesaleOrderNo.includes(',')) {
        wholesaleOrderNos = this.queryForm.wholesaleOrderNo.split(',').filter(item => item);
      } else if (this.queryForm.wholesaleOrderNo) {
        wholesaleOrderNos = [this.queryForm.wholesaleOrderNo];
      }
      getWholesaleOrderList({
        ...this.queryForm,
        wholesaleOrderNos: wholesaleOrderNos,
        vendorIds: this.queryForm.vendorAliasId ? [this.queryForm.vendorAliasId] : (this.queryForm.vendorId ? [this.queryForm.vendorId] : []),
        startTime: this.daterange ? this.daterange[0] : null,
        endTime: this.daterange ? this.daterange[1] : null,
      }).then(res => {
        this.total = res.data.data.total;
        if (res.data.data.list.length > 0) {
          res.data.data.list = res.data.data.list.map((item) => {
            item.subList = [];
            return item;
          });
        }
        this.foldRows();
        this.tableData = res.data.data.list;
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    foldRows() {
      this.tableData.forEach((row) => {
        this.$refs.table.toggleRowExpansion(row, false)
      })
    },
    expandChange(row) {
      if (!row.subList || row.subList.length === 0) {
        getWholesaleOrderDetail({
          wholesaleOrderNo: row.wholesaleOrderNo,
        }).then(res => {
          let index = 0;
          const flag = this.tableData.some((item, i) => {
            index = i;
            return item.wholesaleOrderNo === row.wholesaleOrderNo;
          })
          if (flag) {
            this.tableData[index].subList = res.data.data || [];
          }
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          })
        })
      }
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm');
    },
    batchMerge() {
      if (this.selection.length === 0) {
        return;
      }
      this.$confirm(`确认合并吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        mergeWholesaleOrder(this.selection.map(item => ({
          vendorId: item.vendorId,
          mergeNo: item.wholesaleOrderMergeNo,
          wholesaleOrderNo: item.wholesaleOrderNo,
          wholesaleV1VendorId: item.wholesaleV1VendorId,
        }))).then((res) => {
          if (res.data && res.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
    batchRemove() {
      if (this.selection.length === 0) {
        return;
      }
      this.$confirm(`确认移除吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeWholesaleOrder(this.selection.map(item => item.wholesaleOrderNo)).then((res) => {
          if (res.data && res.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.tr {
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.ml50 {
  margin-left: 50px;
}
.order-page {
  height: 100%;
}
.order-page-aside {
  padding: 20px 10px 20px 20px;
  background-color: rgba(73, 80, 96, 0.1);
}
.order-page-toolbar {
  padding-top: 20px;
}
.order-page-main {
  padding-top: 0;
  padding-bottom: 10px;
}
.query-form {
  max-height: calc(100% - 60px);
  padding-right: 10px;
  margin-bottom: 20px;
  overflow: auto;

  /deep/ .el-form-item__label{
    padding-bottom: 5px;
    line-height: 1.5;
  }
}

</style>
